import { render, staticRenderFns } from "./select-for-goods.vue?vue&type=template&id=68dd693a&"
import script from "./select-for-goods.vue?vue&type=script&lang=js&"
export * from "./select-for-goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports